import { useState } from 'react';
import styled from 'styled-components';
import { SlideModal } from '../../../components/abstract/modal/slide/SlideModal';
import { MainHead } from '../../../components/common/head/MainHead';
import { Icon } from '../../../components/common/icon/Icon';
import {
  TermsOfUseContent,
  TermsOfUseHeader,
  TermsOfUseModalContent,
} from '../../../components/custom/modal/termsOfUseModal/termsOfUseModal';
import { termsOfUse } from '../../../constants/termsOfUse/termsOfUse.constant';
import { useLayout } from '../../../hooks/screen/useLayout';

export const TermsOfUseListPage = () => {
  const [isPluvaMarketEULAModalOpen, setIsPluvaMarketEULAModalOpen] = useState<boolean>(false);
  const [isPersonalInfomationModalOpen, setIsPersonalInfomationModalOpen] = useState<boolean>(false);
  const [isMarketingModalOpen, setIsMarketingModalOpen] = useState<boolean>(false);

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} headerTitle={'서비스 이용 약관'} />,
    fixedHeaderHeight: 48,
    style: {
      background: '#F0f0f0',
    },
  });

  return (
    <>
      <Container>
        <Item onClick={() => setIsPluvaMarketEULAModalOpen(true)}>
          <Title>{'플루바 마켓 회원 이용약관'}</Title>
          <LinkButton>
            <Icon name={'ArrowRightOffblack'} width={14} height={14} />
          </LinkButton>
        </Item>

        <Item onClick={() => setIsPersonalInfomationModalOpen(true)}>
          <Title>{'개인정보 수집 및 이용안내'}</Title>
          <LinkButton>
            <Icon name={'ArrowRightOffblack'} width={14} height={14} />
          </LinkButton>
        </Item>

        <Item onClick={() => setIsMarketingModalOpen(true)}>
          <Title>{'마케팅 목적 개인정보 및 이용안내'}</Title>
          <LinkButton>
            <Icon name={'ArrowRightOffblack'} width={14} height={14} />
          </LinkButton>
        </Item>
      </Container>
      <SlideModal
        isSlideModalOpen={isPluvaMarketEULAModalOpen}
        closeAll={() => setIsPluvaMarketEULAModalOpen(false)}
        showSlideButton={false}
        showBottomCloseButton
      >
        <TermsOfUseModalContent>
          <TermsOfUseHeader>{termsOfUse.pluvaMarket.header.trim()}</TermsOfUseHeader>
          <TermsOfUseContent>{termsOfUse.pluvaMarket.content.trim()}</TermsOfUseContent>
        </TermsOfUseModalContent>
      </SlideModal>
      <SlideModal
        isSlideModalOpen={isPersonalInfomationModalOpen}
        closeAll={() => setIsPersonalInfomationModalOpen(false)}
        showSlideButton={false}
        showBottomCloseButton
      >
        <TermsOfUseModalContent>
          <TermsOfUseHeader>{termsOfUse.personalinfomation.header.trim()}</TermsOfUseHeader>
          <TermsOfUseContent>{termsOfUse.personalinfomation.content.trim()}</TermsOfUseContent>
        </TermsOfUseModalContent>
      </SlideModal>
      <SlideModal
        isSlideModalOpen={isMarketingModalOpen}
        closeAll={() => setIsMarketingModalOpen(false)}
        showSlideButton={false}
        showBottomCloseButton
      >
        <TermsOfUseModalContent>
          <TermsOfUseHeader>{termsOfUse.marketing.header.trim()}</TermsOfUseHeader>
          <TermsOfUseContent>{termsOfUse.marketing.content.trim()}</TermsOfUseContent>
        </TermsOfUseModalContent>
      </SlideModal>
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
  min-height: calc(100vh - 48px);

  background-color: white;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  height: 56px;

  padding: 18px;

  cursor: pointer;
`;

const Title = styled.h3`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 13.6px */
`;

const LinkButton = styled.button`
  padding-right: 5px;
`;
